import { appendIf } from '@btime/helpers'
import { gql, useMutation } from '@apollo/client'

import { generalClient } from '../../../../utils/apollo/api'
import { replaceOrAdd } from '../../../../utils/helpers/lists'
import { useCloseModal, useModalData } from '../../../../components/modals/ModalsContext'
import { useScreen } from '../_load/ScreenLoader'

const MUTATION = gql`
  mutation UpsertScreen($input: ScreenInput) {
    upsertScreen(input: $input) {
      id
      name
    }
  }
`

const cleanRequest = (col, screen, index, isCloning) => ({
  id: screen.id,
  data: JSON.stringify({
    ...screen.data,
    columns: replaceOrAdd(screen.data?.columns || [], col, isCloning ? undefined : index)
  })
})

const validate = (form, setErrors) => {
  const errors = [
    ...appendIf(!form.name, { path: ['name'], message: 'Campo obrigatório' }) //
  ]

  setErrors(errors)
  return errors.length === 0
}

export const useSaveScreen = () => {
  const closeModal = useCloseModal()
  const screen = useScreen()
  const { index, isCloning } = useModalData() || {}

  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Screen'], client: generalClient })

  const handleRequest = (form, actions) => {
    const input = cleanRequest(form, screen, index, isCloning)

    const { setErrors } = actions
    const isValid = validate(form, setErrors)

    if (isValid) {
      return request({ variables: { input } }).then(resp => {
        if (!resp.errors) {
          closeModal()
        }
      })
    }
  }

  return [handleRequest, state]
}
